
import util from '@bmp-vue/core/api/util'

const controller = 'CobrancaServicos1'
export default Object.assign({}, util.GetCrud(controller, ['get', 'post', 'getall', 'put', 'persist']), {
  GetHistorico: function (dto) {
    return util.Axios.GetAll(controller + '/Historico', dto)
  }
})
